import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import ServiceDetail from "./pages/ServiceDetail";
import Blog from "./pages/Blog";
import BlogArticle from "./pages/BlogArticle";
import Calculators from "./pages/Calculators";
import ComplianceCalendar from "./pages/ComplianceCalendar";
import AITools from "./pages/AITools";
import Gallery from "./pages/Gallery";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogArticle />} />
          <Route path="/calculators" element={<Calculators />} />
          <Route path="/compliance-calendar" element={<ComplianceCalendar />} />
          <Route path="/ai-tools" element={<AITools />} />
          <Route path="/gallery" element={<Gallery />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
